import React, { Component } from "react";
import "./solicitud.css";
import Navbar from "../../componentes/navbar/navbar";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import { toast } from "react-toastify";
import { DatePicker } from "react-rainbow-components";
import { solicitudDetalle, apiVincular, apidesvincular, getListaNacionalidad, descargarFacturaxml, descargarFacturapdf, guardarReportes, editarReporte } from "../../service/api";

import { getListaSolicitud, agregarSolicitud, editarSolicitud, eliminarSolicitud, getListaMoneda, ventasListaNoVinculadas, } from "../../service/api";
import SolicitudModal from "../../componentes/modal/solicitud/SolicitudModal";
import ModalMessage from "../../componentes/modal/ModalMessages/ModalMessages";
import { FaSyncAlt, FaTrashAlt } from "react-icons/fa";
import VincularModal from "../../componentes/modal/solicitud/VincularModal";
import VentasNoVinculadasModal from "../../componentes/modal/solicitud/VentasNoVinculadasModal";

import { MdOutlinePictureAsPdf } from "react-icons/md";
import { BsFiletypeXml } from "react-icons/bs";
import SolicitudReporteModal from "../../componentes/modal/solicitud/SolicitudReporteModal";

export default class SolicitudesPage extends Component {


    state = {
        fecha: localStorage.getItem("solicitudes_fecha") || this.toISODate(new Date()),
        solicitudes: [],
        sortKey: "idsolicitudfactura",
        sortDir: "desc",
        selectedRowId: null,

        verVincular: false,
        vincularSel: null,
        ventasVinculadasArr: [],

        verVentasNoVinc: false,
        ventasNoVincArr: [],
        banderaConfirm: "",
        ventaPendiente: null,
        loading: false,
        q: "",
        verMensaje: false,
        modalMessage: "",
        solicitudBorrar: null,
        array_moneda: [],
        array_nacionalidad: [],
        verModal: false,
        modalMode: "create",
        solicitudSel: null,
        //   modalSaving: false,
        verReporteModal: false,
        reporteMode: "create",
        reporteSolicitudSel: null,
        reporteTexto: "",
        reporteFechaTransito: "",
        reporteIdSolicitudFactura: "",
        reporteIdSolicitudFacturaReporte: "",
    };


    componentDidMount() {
        this.setState({ loading: true });

        const datos = localStorage.getItem("datosm");
        if (!datos || datos === "") {
            window.location.href = "/";
            return;
        }

        this.getmonedas();
        this.fetchSolicitudes(this.state.fecha);
    }

    getmonedas = async () => {
        var resp = await getListaMoneda();

        if (resp && resp.code === 0) {
            const array_moneda = resp.data || [];
            this.setState({ array_moneda });
        }

        const respw = await getListaNacionalidad();

        if (respw && respw.code === 0) {
            this.setState({ array_nacionalidad: respw.data || [] });

        } else {
            this.setState({ array_nacionalidad: [] });
        }
    }

    refreshSolicitud = async () => {
        try {
            this.setState({ loading: true });
            await this.fetchSolicitudes(this.state.fecha);
        } catch (e) {
            //     toast.info("No fue posible refrescar");
        }
    };

    openVincular = async (s) => {
        this.setState(
            {
                verVincular: true,
                vincularSel: s,
                loading: true,
                ventasVinculadasArr: [],
            },
            async () => {
                await this.loadVentasVinculadas();
            }
        );
    };

    closeVincular = () => {
        if (this.state.loading) return;

        this.setState({
            verVincular: false,
            vincularSel: null,
            ventasVinculadasArr: [],
            verVentasNoVinc: false,
            ventasNoVincArr: [],
        });
        this.fetchSolicitudes(this.state.fecha);

    };

    loadVentasVinculadas = async () => {
        const sel = this.state.vincularSel;

        if (!sel?.idsolicitudfactura) {
            this.setState({ loading: false });
            return;
        }

        try {
            this.setState({ loading: true });

            const resp = await solicitudDetalle(sel.idsolicitudfactura);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                toast.info(resp?.message || "No se pudo cargar el detalle.");
                this.setState({ ventasVinculadasArr: [] });
                return;
            }

            const arr = Array.isArray(resp?.data) ? resp.data : [];
            const detalle = arr[0] || null;
            const ventas = Array.isArray(detalle?.ventas) ? detalle.ventas : [];

            this.setState({
                vincularSel: detalle || sel,
                ventasVinculadasArr: ventas,
            });
        } catch (e) {
            toast.info("No se pudo cargar el detalle de la solicitud.");
            this.setState({ ventasVinculadasArr: [] });
        } finally {
            this.setState({ loading: false });
        }
    };

    // ===== Helpers =====
    toISODate(dateObj) {
        const y = dateObj.getFullYear();
        const m = String(dateObj.getMonth() + 1).padStart(2, "0");
        const d = String(dateObj.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    parseISOToDate = (iso) => {
        if (!iso) return new Date();
        const [y, m, d] = String(iso).split("-").map(Number);
        return new Date(y, (m || 1) - 1, d || 1);
    };

    money = (n) => {
        const val = Number(n || 0);
        return val.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // ===== API =====
    fetchSolicitudes = async (fechaISO) => {
        this.setState({ loading: true });


        try {
            const resp = await getListaSolicitud({ fecha: fechaISO });

            if (resp?.code === 0) {
                const raw = resp?.data || [];
                const arr = Array.isArray(raw) ? raw : raw?.data || [];
                this.setState({
                    solicitudes: arr,
                    loading: false,
                    selectedRowId: null,
                });
                return;
            }

            if (resp?.code === 2003) {
                this.setState({ loading: false });
                return;
            }

            this.setState({ loading: false });
            toast.info(resp?.message || "No se pudo cargar solicitudes.");
        } catch (e) {
            this.setState({ solicitudes: [], loading: false });
            toast.info("Error al cargar solicitudes.");
        }
    };

    // ===== UI handlers =====
    onChangeFecha = (dateObj) => {
        if (!dateObj) return;
        const fechaISO = this.toISODate(dateObj);
        localStorage.setItem("solicitudes_fecha", fechaISO);
        this.setState({ fecha: fechaISO }, () => this.fetchSolicitudes(fechaISO));
    };

    setHoy = () => {
        const hoyISO = this.toISODate(new Date());
        localStorage.setItem("solicitudes_fecha", hoyISO);
        this.setState({ fecha: hoyISO }, () => this.fetchSolicitudes(hoyISO));
    };

    onSelectRow = (rowId) => {
        this.setState((prev) => ({
            selectedRowId: prev.selectedRowId === rowId ? null : rowId,
        }));
    };

    openCreate = () => {
        this.setState({
            verModal: true,
            modalMode: "create",
            solicitudSel: null,
        });
    };

    openEdit = (s) => {
        this.setState({
            verModal: true,
            modalMode: "edit",
            solicitudSel: s,
            selectedRowId: String(s?.idsolicitudfactura),
        });
    };

    closeModal = () => {
        if (this.state.loading) return;
        this.setState({ verModal: false, solicitudSel: null });
    };

    // ===== Sorting (simple) =====
    compareValues = (a, b) => {
        if (a == null) a = "";
        if (b == null) b = "";

        const na = Number(a);
        const nb = Number(b);

        const bothNumeric =
            !Number.isNaN(na) &&
            !Number.isNaN(nb) &&
            String(a).trim() !== "" &&
            String(b).trim() !== "";

        if (bothNumeric) return na - nb;
        return String(a).localeCompare(String(b), "es", { numeric: true, sensitivity: "base" });
    };

    getSortValue = (s, key) => {
        switch (key) {
            case "idsolicitudfactura":
                return s.idsolicitudfactura;
            case "idticket":
                return s.idticket;
            case "fecha_transito":
                return s.fecha_transito;
            case "nombre":
                return s.nombre;
            case "apellido":
                return s.apellido;
            case "nacionalidad":
                return s.nacionalidad;
            case "pasaporte":
                return s.pasaporte;
            case "via":
                return s.via;
            case "locacion":
                return s.locacion;
            case "cantidad":
                return s.cantidad;
            case "moneda":
                return s.moneda;
            case "carpeta":
                return s.carpeta;
            case "comentarios":
                return s.comentarios;
            case "estatus":
                return s.estatus;
            case "reporte":
                return s.idsolicitudfacturareporte;
            case "factura":
                return s.folio;
            default:
                return "";
        }
    };

    onSort = (key) => {
        this.setState((prev) => {
            const same = prev.sortKey === key;
            const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
            return { sortKey: key, sortDir: nextDir };
        });
    };

    getSortedItems = () => {
        const { solicitudes, sortKey, sortDir } = this.state;

        return [...(solicitudes || [])].sort((sa, sb) => {
            const a = this.getSortValue(sa, sortKey);
            const b = this.getSortValue(sb, sortKey);
            const cmp = this.compareValues(a, b);
            return sortDir === "asc" ? cmp : -cmp;
        });
    };



    normalizeText = (v) =>
        String(v ?? "")
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

    getFilteredItems = (items) => {
        const q = this.normalizeText(this.state.q).trim();
        if (!q) return items;

        return (items || []).filter((s) => {
            const hay = [
                s?.idsolicitudfactura,
                s?.idticket,
                s?.fecha_transito,
                s?.nombre,
                s?.apellido,
                s?.nacionalidad,
                s?.pasaporte,
                s?.via,
                s?.locacion,
                s?.cantidad,
                s?.moneda,
                s?.comentarios,
                s?.carpeta,
                s?.estatus,
                s?.idestatus,
                s?.idsolicitudfacturareporte,
                s?.folio

            ]
                .map(this.normalizeText)
                .join(" ");

            return hay.includes(q);
        });
    };


    // ===== Save (create/edit) =====
    onSaveSolicitud = async (payload, mode, original) => {
        this.setState({ loading: true });

        try {
            let resp;

            if (mode === "create") {
                resp = await agregarSolicitud(payload);
            } else {
                if (typeof editarSolicitud !== "function") {
                    this.setState({ loading: false });
                    return;
                }

                resp = await editarSolicitud(original?.idsolicitudfactura, payload);
            }

            if (resp?.code === 0) {
                toast.success(mode === "create" ? "Solicitud agregada." : "Solicitud actualizada.");

                this.setState({
                    verModal: false,
                    solicitudSel: null,
                });

                await this.fetchSolicitudes(this.state.fecha);
            } else {
                toast.info(`${resp?.message ?? "No se pudo guardar."}`);
                await this.fetchSolicitudes(this.state.fecha);
            }
        } catch (e) {
            toast.info("Error al guardar la solicitud.");
        } finally {
            this.setState({ loading: false });
        }
    };

    confirmEliminar = (s) => {
        // puedes mostrar ticket + nombre para que quede claro
        const label = `la solicitud #${s?.idsolicitudfactura} (Ticket ${s?.idticket} - ${s?.nombre ?? ""} ${s?.apellido ?? ""})`;

        this.setState({
            verMensaje: true,
            modalMessage: label,
            solicitudBorrar: s,
        });
    };

    confirmDesvincular = (venta) => {
        const s = this.state.vincularSel;
        const label = `¿Deseas desvincular la venta #${venta?.idticketpago} al ticket #${s?.idticket}?`;

        this.setState({
            verMensaje: true,
            modalMessage: label,
            banderaConfirm: "desvincular",
            ventaPendiente: venta,
        });
    };
    cerrarBorrar = async (response) => {
        // 0 = cancelar
        if (response === 0) {
            this.setState({
                verMensaje: false,
                modalMessage: "",
                solicitudBorrar: null,
                banderaConfirm: "",
                ventaPendiente: null,
            });
            return;
        }
        // CASO: MARCAR REPORTE COMO RESUELTO
        if (this.state.banderaConfirm === "resolverReporte") {
            this.setState({
                verMensaje: false,
                modalMessage: "",
                banderaConfirm: "",
                verReporteModal: false
            });

            await this.marcarReporteResuelto();
            return;
        }

        //  CASO: DESVINCULAR
        if (this.state.banderaConfirm === "desvincular") {
            const s = this.state.vincularSel;
            const v = this.state.ventaPendiente;

            // console.log("Desvincular - solicitud:", s);
            //// consolelog("Desvincular - venta:", v);
            // cerramos confirmación (y limpiamos bandera)
            this.setState({ verMensaje: false, modalMessage: "" });

            if (!s?.idsolicitudfactura || !v?.idticketpago) {
                toast.info("No se encontró información para desvincular.");
                this.setState({ banderaConfirm: "", ventaPendiente: null });
                return;
            }

            try {
                this.setState({ loading: true });

                const resp = await apidesvincular(s.idsolicitudfactura, v.idticketpago);

                if (resp?.code === 0 || resp?.success) {
                    toast.success(resp?.message || "Venta desvinculada.");
                    await this.loadVentasVinculadas();
                } else {
                    toast.info(resp?.message || "No se pudo desvincular.");
                }
            } catch (e) {
                toast.info("Error al desvincular.");
            } finally {
                this.setState({
                    loading: false,
                    banderaConfirm: "",
                    ventaPendiente: null,
                });
            }
            return;
        }

        //  CASO: ELIMINAR SOLICITUD
        const s = this.state.solicitudBorrar;

        if (!s?.idsolicitudfactura) {
            this.setState({ verMensaje: false, modalMessage: "", solicitudBorrar: null });
            toast.info("No se encontró la solicitud a eliminar.");
            return;
        }

        try {
            this.setState({
                loading: true,
                verMensaje: false,
                banderaConfirm: "",
                ventaPendiente: null,
            });

            const resp = await eliminarSolicitud(s.idsolicitudfactura);

            if (resp?.code === 0) {
                toast.success(resp?.message || "Solicitud eliminada.");
                this.setState({ solicitudBorrar: null, loading: false, selectedRowId: null });
                this.fetchSolicitudes(this.state.fecha);
            } else {
                toast.info(`${resp?.message ?? "No se pudo eliminar."}`);
                this.setState({ solicitudBorrar: null });
                this.fetchSolicitudes(this.state.fecha);
            }
        } catch (e) {
            this.setState({ solicitudBorrar: null });
            toast.info("Error al eliminar la solicitud.");
            this.fetchSolicitudes(this.state.fecha);
        }
    };

    truncateText = (text, max = 40) => {
        const t = String(text ?? "").trim();
        if (t.length <= max) return t;
        return t.slice(0, max) + "...";
    };



    addVentaToSolicitud = async (venta) => {
        const s = this.state.vincularSel;

        if (!s?.idsolicitudfactura || !venta?.idticketpago) return;

        try {
            this.setState({ loading: true });

            const resp = await apiVincular(s.idsolicitudfactura, venta.idticketpago);

            if (resp?.code === 0 || resp?.success || resp?.ok) {
                toast.success(resp?.message || "Venta vinculada.");

                this.setState(
                    { verVentasNoVinc: false, ventasNoVincArr: [] },
                    this.loadVentasVinculadas
                );
            } else {
                toast.info(resp?.message || "No se pudo vincular.");
            }
        } catch (e) {
            toast.info("Error al vincular.");
        } finally {
            this.setState({ loading: false });
        }
    };

    openVentasNoVinculadas = async () => {
        const s = this.state.vincularSel;
        const idticket = s?.idticket;

        try {
            this.setState({
                verVentasNoVinc: true,
                loading: true,
                ventasNoVincArr: [],
            });

            const resp = await ventasListaNoVinculadas(idticket);
            const arr = resp?.data || resp || [];

            this.setState({
                ventasNoVincArr: Array.isArray(arr) ? arr : [],
            });
        } catch (e) {
            toast.info("No se pudo cargar ventas para vincular.");
            this.setState({ ventasNoVincArr: [] });
        } finally {
            this.setState({ loading: false });
        }
    };

    closeVentasNoVinc = () => {
        if (this.state.loading) return;

        this.setState({
            verVentasNoVinc: false,
            ventasNoVincArr: [],
        });
    };

    getRole = () => {
        try {
            const raw = localStorage.getItem("sharem");
            const j = raw ? JSON.parse(raw) : {};
            return String(j?.role || "").trim().toLowerCase();
        } catch (e) {
            return "";
        }
    };

    canVincular = () => {
        const r = this.getRole();
        return r === "administrador" || r === "contador";
    };

    getEstatusClass = (id) => {
        const map = {
            1: "none",
            4: "green",
            5: "warn",
            3: "blue",
        };
        return map[Number(id)] || "none";
    };

    openReporteSolicitud = async (s) => {
        if (!s?.idsolicitudfactura) {
            toast.info("No se encontró la solicitud.");
            return;
        }

        const idReporte = Number(s?.idsolicitudfacturareporte || 0);
        const tieneReporte = idReporte > 0;

        this.setState({
            selectedRowId: String(s?.idsolicitudfactura),
        });

        // NUEVO REPORTE
        if (!tieneReporte) {
            this.setState({
                verReporteModal: true,
                reporteMode: "create",
                reporteSolicitudSel: s,
                reporteTexto: "",
                reporteFechaTransito: s?.fecha_transito || "",
                reporteIdSolicitudFactura: s?.idsolicitudfactura,
                reporteIdSolicitudFacturaReporte: "",
            });

            return;
        }

        // EDITAR REPORTE
        this.setState({
            verReporteModal: true,
            reporteMode: "edit",
            reporteSolicitudSel: s,
            reporteTexto: s?.reporte || "",
            reporteFechaTransito: s?.fecha_transito || "",
            reporteIdSolicitudFactura: s?.idsolicitudfactura,
            reporteIdSolicitudFacturaReporte: s?.idsolicitudfacturareporte,
        });
    };

    closeReporteSolicitud = () => {
        if (this.state.loading) return;

        this.setState({
            verReporteModal: false,
            reporteMode: "create",
            reporteSolicitudSel: null,
            reporteTexto: "",
            reporteFechaTransito: "",
            reporteIdSolicitudFactura: "",
            reporteIdSolicitudFacturaReporte: "",
        });
    };

    onChangeReporteSolicitud = (e) => {
        this.setState({
            reporteTexto: e.target.value,
        });
    };

    validarReporteSolicitud = () => {
        const reporte = String(this.state.reporteTexto || "").trim();

        if (!reporte) {
            toast.warning("El reporte no puede ir vacío");
            return false;
        }

        return true;
    };

    guardarReporteSolicitud = async () => {
        if (!this.validarReporteSolicitud()) return;
    
        const {
            reporteMode,
            reporteIdSolicitudFactura,
            reporteIdSolicitudFacturaReporte,
            reporteTexto
        } = this.state;
    
        try {
            this.setState({ verReporteModal: false, loading: true });
    
            let resp;
    
            if (reporteMode === "create") {
                const json = {
                    idsolicitudfactura: reporteIdSolicitudFactura,
                    reporte: reporteTexto,
                };
    
                resp = await guardarReportes(json);
            } else {
                const datos = {
                    reporte: reporteTexto,
                    resuelto: "",
                };
    
                resp = await editarReporte(
                    reporteIdSolicitudFacturaReporte,
                    datos
                );
            }
    
            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }
    
            toast.success(
                reporteMode === "create"
                    ? "Reporte creado correctamente"
                    : "Reporte actualizado correctamente"
            );
    
            window.dispatchEvent(new Event("reportes:refresh"));
    
            this.closeReporteSolicitud();
            await this.fetchSolicitudes(this.state.fecha);
    
        } catch (error) {
            console.error(error);
            toast.error("No se pudo guardar el reporte");
        } finally {
            this.setState({ loading: false });
        }
    };

    confirmarReporteResuelto = () => {
        this.setState({
            verMensaje: true,
            modalMessage: "este reporte",
            banderaConfirm: "resolverReporte",
        });
    };

    marcarReporteResuelto = async () => {
        if (!this.validarReporteSolicitud()) return;

        const {
            reporteIdSolicitudFacturaReporte,
            reporteTexto,
        } = this.state;

        if (!reporteIdSolicitudFacturaReporte) {
            toast.info("No se encontró el reporte para resolver.");
            return;
        }

        try {
            this.setState({ loading: true });

            const datos = {
                reporte: reporteTexto,
                resuelto: 1,
            };

            const resp = await editarReporte(
                reporteIdSolicitudFacturaReporte,
                datos
            );

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            toast.success("Reporte marcado como resuelto");
            window.dispatchEvent(new Event("reportes:refresh"));


            this.closeReporteSolicitud();
            await this.fetchSolicitudes(this.state.fecha);
        } catch (error) {
            console.error(error);
            toast.error("No se pudo marcar como resuelto");
        } finally {
            this.setState({ loading: false });
        }
    };

    downloadTextFile = (textData, fileName, mimeType) => {
        try {
            const blob = new Blob([String(textData || "")], {
                type: `${mimeType};charset=utf-8`,
            });

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);
        } catch (e) {
            toast.info("No se pudo descargar el archivo.");
        }
    };

    handleDescargarSolicitudXml = async (s) => {
        const folio = String(s?.folio || "").trim();

        if (!folio) {
            toast.info("No se encontró el folio para descargar XML.");
            return;
        }

        try {
            this.setState({ loading: true });

            const resp = await descargarFacturaxml(folio);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                toast.info(resp?.message || "No se pudo descargar el XML.");
                return;
            }

            const xml = String(resp?.data || "").trim();

            if (!xml) {
                toast.info("No se recibió el XML para descargar.");
                return;
            }

            this.downloadTextFile(
                xml,
                `factura_${folio}.xml`,
                "application/xml"
            );
        } catch (error) {
            toast.info("Error al descargar XML.");
        } finally {
            this.setState({ loading: false });
        }
    };

    handleDescargarSolicitudPdf = async (s) => {
        const folio = String(s?.folio || "").trim();

        if (!folio) {
            toast.info("No se encontró el folio para descargar PDF.");
            return;
        }

        try {
            this.setState({ loading: true });

            const resp = await descargarFacturapdf(folio);

            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                toast.info(resp?.message || "No se pudo descargar el PDF.");
                return;
            }

            const blob = resp?.data;

            if (!(blob instanceof Blob)) {
                toast.info("No se recibió un archivo PDF válido.");
                return;
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = url;
            a.download = `factura_${folio}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            }, 1000);
        } catch (error) {
            console.error("ERROR PDF:", error);
            toast.info("Error al descargar PDF.");
        } finally {
            this.setState({ loading: false });
        }
    };

    renderFacturaIcons = (s) => {
        const folio = String(s?.folio || "").trim();
        const enabled = folio.length > 0;

        return (
            <div className="fa-files" onClick={(e) => e.stopPropagation()}>
                <button
                    type="button"
                    className={`fa-fileBtn ${enabled ? "is-enabled" : "is-disabled"}`}
                    onClick={() => this.handleDescargarSolicitudXml(s)}
                    title={enabled ? "Descargar XML" : "XML no disponible"}
                    disabled={!enabled || this.state.loading}
                >
                    <BsFiletypeXml />
                </button>

                <button
                    type="button"
                    className={`fa-fileBtn ${enabled ? "is-enabled" : "is-disabled"}`}
                    onClick={() => this.handleDescargarSolicitudPdf(s)}
                    title={enabled ? "Descargar PDF" : "PDF no disponible"}
                    disabled={!enabled || this.state.loading}
                >
                    <MdOutlinePictureAsPdf />
                </button>
            </div>
        );
    };

    render() {
        const { loading, fecha, selectedRowId, verModal, modalMode, solicitudSel, array_moneda } = this.state;
        const sorted = this.getSortedItems();
        const items = this.getFilteredItems(sorted);

        return (
            <div className="v-page">
                <Navbar />

                {loading ? <SpinnerModal tipo="full" show={loading} /> : null}

                <ModalMessage
                    show={this.state.verMensaje}
                    titulo="Confirmar"
                    mensaje={this.state.modalMessage}
                    bandera={this.state.banderaConfirm || "eliminar"}
                    cerrarBorrar={this.cerrarBorrar}
                />

                <SolicitudModal
                    show={verModal}
                    mode={modalMode}
                    solicitud={solicitudSel}
                    loading={loading}
                    moneda={array_moneda}
                    onClose={this.closeModal}
                    onSave={this.onSaveSolicitud}
                    array_nacionalidad={this.state.array_nacionalidad}
                    fechaPage={this.state.fecha}
                />
                <VincularModal
                    show={this.state.verVincular}
                    onClose={this.closeVincular}
                    solicitud={this.state.vincularSel}              //  solicitud con ventas y datos
                    loading={loading}
                    ventasVinculadas={this.state.ventasVinculadasArr} //  solo ventas
                    onClickAgregar={this.openVentasNoVinculadas}
                    onDesvincular={this.confirmDesvincular}
                />

                <VentasNoVinculadasModal
                    show={this.state.verVentasNoVinc}
                    onClose={this.closeVentasNoVinc}
                    loading={loading}
                    ventas={this.state.ventasNoVincArr}
                    onAddVenta={this.addVentaToSolicitud}
                />

                <SolicitudReporteModal
                    show={this.state.verReporteModal}
                    mode={this.state.reporteMode}
                    reporte={this.state.reporteTexto}
                    fechaTransito={this.state.reporteFechaTransito}
                    loading={loading}
                    onClose={this.closeReporteSolicitud}
                    onChangeReporte={this.onChangeReporteSolicitud}
                    onGuardar={this.guardarReporteSolicitud}
                    onResuelto={this.confirmarReporteResuelto}
                />

                <div className="so-shell">
                    <div className="v-top">
                        <h1 className="v-title">Solicitudes</h1>

                        <div className="v-actions">


                            <div className="so-search">
                                <span className="so-ico" aria-hidden="true">🔎</span>
                                <input
                                    type="text"
                                    value={this.state.q}
                                    onChange={(e) => this.setState({ q: e.target.value, selectedRowId: null })}
                                    placeholder="Buscar ticket, nombre..."
                                    disabled={loading}
                                />
                                {String(this.state.q || "").length > 0 && (
                                    <button
                                        type="button"
                                        className="so-clear"
                                        onClick={() => this.setState({ q: "", selectedRowId: null })}
                                        disabled={loading}
                                        aria-label="Limpiar búsqueda"
                                        title="Limpiar"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>



                            <div className="v-date">
                                <button
                                    type="button"
                                    className="v-btnHoy"
                                    onClick={this.setHoy}
                                    disabled={loading}
                                    title="Fecha actual"
                                >
                                    Hoy
                                </button>

                                <DatePicker
                                    id="ventas-date"
                                    value={this.parseISOToDate(fecha)}
                                    onChange={this.onChangeFecha}
                                    formatStyle="large"
                                    placeholder="Selecciona fecha"
                                />

                                <button
                                    type="button"
                                    className="v-btnRefresh"
                                    onClick={this.refreshSolicitud}
                                    disabled={loading}
                                >
                                    <FaSyncAlt />
                                </button>
                            </div>


                            <button className="v-btn" onClick={this.openCreate} disabled={loading}>
                                AGREGAR SOLICITUD
                            </button>
                        </div>
                    </div>

                    <div className="vard">
                        <div className="v-card">
                            <div className="v-tableWrap">
                                <table className="v-table v-table--sol">
                                    <thead>
                                        <tr>
                                            <th className="v-thSort" onClick={() => this.onSort("idticket")}>Ticket</th>
                                            <th className="v-thSort" onClick={() => this.onSort("fecha_transito")}>Fecha tránsito</th>
                                            <th className="v-thSort" onClick={() => this.onSort("nombre")}>Nombre</th>
                                            <th className="v-thSort" onClick={() => this.onSort("apellido")}>Apellido</th>
                                            <th className="v-thSort" onClick={() => this.onSort("nacionalidad")}>Nacionalidad</th>
                                            <th className="v-thSort" onClick={() => this.onSort("pasaporte")}>Pasaporte</th>
                                            <th className="v-thSort" onClick={() => this.onSort("via")}>Vía</th>
                                            <th className="v-thSort" onClick={() => this.onSort("locacion")}>Locación</th>
                                            <th className="v-thSort v-num" onClick={() => this.onSort("cantidad")}>Cantidad</th>
                                            <th className="v-thSort" onClick={() => this.onSort("moneda")}>Moneda</th>
                                            <th className="v-thSort  v-col-comentarios" onClick={() => this.onSort("comentarios")}>Comentarios</th>
                                            <th className="v-thSort" onClick={() => this.onSort("carpeta")}>Carpeta</th>
                                            <th className="v-thSort" onClick={() => this.onSort("estatus")}>Estatus</th>
                                            <th className="v-thSort" onClick={() => this.onSort("factura")}>Factura</th>
                                            <th className="v-thSort" onClick={() => this.onSort("reporte")}>Gestión</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr>
                                                <td colSpan="15" className="v-empty">
                                                    {this.state.q ? "Sin resultados para la búsqueda" : "No hay registros disponibles"}
                                                </td>                                            </tr>
                                        ) : (
                                            items.map((s, idx) => {
                                                const rowId = String(s?.idsolicitudfactura ?? idx);
                                                const isActive = selectedRowId === rowId;

                                                return (
                                                    <tr
                                                        key={`${rowId}-${idx}`}
                                                        className={`${isActive ? "row-active" : ""} ${Number(s?.idsolicitudfacturareporte) > 0 ? "row-reporte" : ""}`}
                                                        onClick={() => this.onSelectRow(rowId)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <td className="v-mono"><strong>{s.idticket}</strong></td>
                                                        <td className="v-mono">{s.fecha_transito || ""}</td>
                                                        <td>{s.nombre || ""}</td>
                                                        <td>{s.apellido || ""}</td>
                                                        <td className="v-mono">{s.nacionalidad || ""}</td>
                                                        <td className="v-mono">{s.pasaporte || ""}</td>
                                                        <td className="v-mono">{s.via || ""}</td>
                                                        <td>{s.locacion || ""}</td>
                                                        <td className="v-num">{this.money(s.cantidad)}</td>
                                                        <td className="v-mono">{s.moneda || ""}</td>
                                                        <td
                                                            className="v-mono  v-col-comentarios"
                                                            title={s.comentarios || ""}
                                                        >
                                                            {this.truncateText(s.comentarios, 30)}
                                                        </td>
                                                        <td className="v-mono">
                                                            {(() => {
                                                                const carpetaRaw = String(s?.carpeta ?? "").trim();
                                                                if (!carpetaRaw) return "";

                                                                const url = /^https?:\/\//i.test(carpetaRaw) ? carpetaRaw : `https://${carpetaRaw}`;

                                                                return (
                                                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>


                                                                        <button
                                                                            type="button"
                                                                            className="v-miniBtn"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                window.open(url, "_blank", "noopener,noreferrer");
                                                                            }}
                                                                            title="Abrir carpeta"
                                                                        >
                                                                            Ver
                                                                        </button>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </td>


                                                        <td>
                                                            <span className={`v-badge ${this.getEstatusClass(s.idestatus)}`}>
                                                                {s.estatus ?? ""}
                                                            </span>
                                                        </td>

                                                        <td>{this.renderFacturaIcons(s)}</td>

                                                        <td className="so-gestion-td" onClick={(e) => e.stopPropagation()}>
                                                            <div className="so-gestion-box">
                                                                <div className="so-gestion-row">
                                                                    <button
                                                                        type="button"
                                                                        className="so-gestion-btn so-gestion-btn--edit"
                                                                        onClick={() => this.openEdit(s)}
                                                                        disabled={loading}
                                                                        title="Editar solicitud"
                                                                    >
                                                                        <span className="so-gestion-icon" aria-hidden="true">
                                                                            <svg viewBox="0 0 24 24" fill="none">
                                                                                <path
                                                                                    d="M4 20h4l10.5-10.5a1.8 1.8 0 0 0 0-2.5l-1.5-1.5a1.8 1.8 0 0 0-2.5 0L4 16v4Z"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth="1.8"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M13.5 6.5l4 4"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth="1.8"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                            </svg>
                                                                        </span>
                                                                        Editar
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        className="so-gestion-btn so-gestion-btn--delete"
                                                                        onClick={() => this.confirmEliminar(s)}
                                                                        disabled={loading}
                                                                        title="Eliminar"
                                                                        aria-label="Eliminar"
                                                                    >
                                                                        <FaTrashAlt />
                                                                    </button>
                                                                </div>
                                                                <div className="so-gestion-row">
                                                                    <button
                                                                        type="button"
                                                                        className={`so-gestion-btn so-gestion-btn--reporte ${Number(s?.idsolicitudfacturareporte || 0) > 0
                                                                            ? "so-gestion-btn--reporte-edit"
                                                                            : ""
                                                                            }`}
                                                                        onClick={() => this.openReporteSolicitud(s)}
                                                                        disabled={loading}
                                                                        title={
                                                                            Number(s?.idsolicitudfacturareporte || 0) > 0
                                                                                ? "Ver Reporte"
                                                                                : "Reportar"
                                                                        }
                                                                    >
                                                                        {Number(s?.idsolicitudfacturareporte || 0) > 0
                                                                            ? "Ver Reporte"
                                                                            : "Reportar"}
                                                                    </button>

                                                                    {this.canVincular() && (
                                                                        <button
                                                                            type="button"
                                                                            className="so-gestion-btn so-gestion-btn--vincular"
                                                                            onClick={() => this.openVincular(s)}
                                                                            disabled={loading}
                                                                            title="Vincular"
                                                                        >
                                                                            Vincular
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </td>




                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
